/*@flow*/
import React from 'react';
import type { HTMLAttributes } from '../types';

export default function Help({
  help,
  attrs,
}: {
  help: React$Node,
  attrs: HTMLAttributes,
}): React$Node {
  if (!help) return null;
  return (
    <span className="form-text text-muted" id={`${attrs.id}-tip`}>
      {help}
    </span>
  );
}
